"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Indent2 = {
    elemName: '字下げ二',
    type: 'block',
    doc: '二文字分字下げがある箇所を囲むブロックです',
    example: '％字下げ二\nこの部分が字下げされます\n％',
    textTemplate: '{{$1}}',
    htmlTemplate: `<div {{{$htmlId}}} class="Indent2 {{$classes}}">{{{$1}}}</div>`,
    xmlTemplate: `<div rend="indent(-2)" {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</div>`,
    docxTemplate: `<w:p>{{{$1}}}</w:p>`
};
exports.default = Indent2;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5kZW50Mi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb252ZXJ0ZXIvYmxvY2tfcnVsZXMvSW5kZW50Mi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLE1BQU0sT0FBTyxHQUFtQjtJQUMvQixRQUFRLEVBQUUsTUFBTTtJQUNoQixJQUFJLEVBQUUsT0FBTztJQUNiLEdBQUcsRUFBRSx1QkFBdUI7SUFDNUIsT0FBTyxFQUFFLHdCQUF3QjtJQUNqQyxZQUFZLEVBQUUsUUFBUTtJQUN0QixZQUFZLEVBQUUsZ0VBQWdFO0lBQzlFLFdBQVcsRUFBRSx1RUFBdUU7SUFDcEYsWUFBWSxFQUFFLHFCQUFxQjtDQUNuQyxDQUFDO0FBRUYsa0JBQWUsT0FBTyxDQUFDIn0=